export const slideStyles = (theme) => ({
  paper: {
    height: "100vh",
    minHeight: "100vh",
    width: "100%",
    maxWidth: "400px",
    position: "absolute",
    borderRadius: "4px 0px 0px 4px",
    margin: 0,
    right: 0,
    zIndex: "99999",
    border: ({ border }) => (border ? "2px #3D92FF solid" : ""),
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
    },
  },
  title: {
    color: "#6F6F6F",
    padding: ({ paddingReduce }) => (paddingReduce ? "0px 24px" : "16px 24px"),
  },
  dialogContent: {
    padding: ({ paddingReduce }) => (paddingReduce ? "0px 24px" : "8px 24px"),
  },
  dialogActions: {
    display: "flex",
    justifyContent: "space-around",
  },
})

export const centerStyles = (theme) => ({
  paper: {
    width: "100%",
    maxWidth: ({ widthLarge }) => (widthLarge ? widthLarge : "400px"),
    position: "absolute",
    borderRadius: "4px 0px 0px 4px",
    zIndex: "99999",
    border: ({ border }) => (border ? "2px #3d92ff solid" : ""),

    [theme.breakpoints.down("sm")]: {
      maxWidth: "100%",
    },
  },
  title: {
    color: "#6F6F6F",
    padding: ({ paddingReduce }) => (paddingReduce ? "0px 24px" : "16px 24px"),
  },
  dialogContent: {
    padding: ({ paddingReduce }) => (paddingReduce ? "0px 24px" : "8px 24px"),
  },
  dialogActions: {
    display: "flex",
    justifyContent: "flex-end",
  },
})
